import { type DragEvent, useRef, useState } from "react";

/** Drag-and-drop handlers for a file drop area, plus whether a file is over it. */
export const useFileDropZone = (
  onDropFiles: (files: FileList) => void,
  isDisabled = false,
) => {
  // Counts dragenter minus dragleave, which also fire for the area's children.
  const dragDepth = useRef(0);
  const [isDragOver, setIsDragOver] = useState(false);

  const resetDragState = () => {
    dragDepth.current = 0;
    setIsDragOver(false);
  };

  const dropZoneProps = {
    onDragEnter: (event: DragEvent<HTMLElement>) => {
      if (isDisabled) return;
      event.preventDefault();
      event.stopPropagation();
      dragDepth.current += 1;
      setIsDragOver(true);
    },
    onDragLeave: (event: DragEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      dragDepth.current -= 1;
      if (dragDepth.current <= 0) resetDragState();
    },
    onDragOver: (event: DragEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
    },
    onDrop: (event: DragEvent<HTMLElement>) => {
      if (isDisabled) return;
      event.preventDefault();
      event.stopPropagation();
      resetDragState();
      onDropFiles(event.dataTransfer.files);
    },
  };

  return { isDragOver, dropZoneProps };
};
